// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ceaP","content":"styles_content__3uPRd","tableWrap":"styles_tableWrap__1gBmt"};